// import React, { useState, useEffect } from 'react';
// import {
//     Box,
//     Button,
//     Table,
//     TableHead,
//     TableBody,
//     TableRow,
//     TableCell,
//     TextField,
//     MenuItem,
//     Select,
//     FormControl,
//     InputLabel,
//     Typography,
//     CircularProgress,
//     Tooltip,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     IconButton,
//     Divider
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import { useMain } from 'src/views/hooks/useMain';

// const AddProductConsume = ({ billId, onClose }) => {
//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [selectedProducts, setSelectedProducts] = useState([]);
//     const [quantities, setQuantities] = useState({});
//     const [units, setUnits] = useState({});
//     const [hasMappedProducts, setHasMappedProducts] = useState(false);

//     const { activeBranchId, setShowMessage, fetchServicesBillById, saveConsumedProducts } = useMain();

//     useEffect(() => {
//         if (activeBranchId && billId) {
//             getData();
//         }
//     }, [activeBranchId, billId]);

//     const getData = async () => {
//         try {
//             setLoading(true);
//             const res = await fetchServicesBillById(billId, activeBranchId);
//             if (res.statusCode === 200) {
//                 setData(res.data);
//                 // Check if any service has mapped products
//                 const hasProducts = res.data?.services?.some(
//                     service => service?.service?.mappedProducts?.length > 0
//                 );
//                 setHasMappedProducts(hasProducts);
//             } else {
//                 setShowMessage({
//                     message: res.message || 'Failed to fetch data',
//                     messageType: 'error',
//                 });
//             }
//         } catch (error) {
//             console.error("Error fetching bill:", error);
//             setShowMessage({
//                 message: 'Error fetching bill data',
//                 messageType: 'error'
//             });
//         } finally {
//             setLoading(false);
//         }
//     };
//   console.log(data,'data')
//   console.log(hasMappedProducts,'hasMappedProducts')
//     useEffect(() => {
//         if (data && hasMappedProducts) {
//             const initialSelected = {};
//             const initialQuantities = {};
//             const initialUnits = {};

//             data?.services?.forEach((service, index) => {
//                 if (service?.service?.mappedProducts?.length > 0) {
//                     initialSelected[index] = '';
//                     initialQuantities[index] = '';
//                     initialUnits[index] = '';
//                 }
//             });

//             setSelectedProducts(initialSelected);
//             setQuantities(initialQuantities);
//             setUnits(initialUnits);
//         }
//     }, [data, hasMappedProducts]);

//     const handleProductChange = (index, productId) => {
//         setSelectedProducts(prev => ({
//             ...prev,
//             [index]: productId
//         }));

//         const selectedService = data.services[index].service;
//         const selectedProduct = selectedService.mappedProducts.find(p => p._id === productId);
//         if (selectedProduct) {
//             setUnits(prev => ({
//                 ...prev,
//                 [index]: selectedProduct.productUnit
//             }));
//         } else {
//             setUnits(prev => ({
//                 ...prev,
//                 [index]: ''
//             }));
//         }
//     };

//     const handleQuantityChange = (index, value) => {
//         setQuantities(prev => ({
//             ...prev,
//             [index]: value
//         }));
//     };

//     const handleSubmit = async () => {
//         try {
//             setLoading(true);
//             const consumedProducts = data.services
//                 .map((service, index) => {
//                     if (!service.service.mappedProducts || service.service.mappedProducts.length === 0) {
//                         return null;
//                     }

//                     const selectedProductId = selectedProducts[index];
//                     if (!selectedProductId || selectedProductId === '') {
//                         return null;
//                     }

//                     const quantity = quantities[index];
//                     if (!quantity || quantity === '' || Number(quantity) <= 0) {
//                         return null;
//                     }

//                     return {
//                         serviceId: service.service._id,
//                         usedProductId: selectedProductId,
//                         usedProductAmount: Number(quantity),
//                         remainingProductUnit: units[index] || 'ml',
//                         consumptionServiceProviderId:service?.serviceProvider ||  []
//                     };
//                 })
//                 .filter(update => update !== null);

//             if (consumedProducts.length === 0) {
//                 setShowMessage({
//                     message: 'Please select at least one product with valid quantity',
//                     messageType: 'error'
//                 });
//                 return;
//             }

//             const payload = {
//                 consumedProducts,
//                 dateOfBilling: data.dateOfBilling
//             };

//             const res = await saveConsumedProducts(billId, activeBranchId, payload);

//             if (res?.statusCode === 200) {
//                 setShowMessage({
//                     message: res.message || 'Product consumption saved successfully',
//                     messageType: 'success'
//                 });
//                 if (onClose) onClose(true); // Pass true to indicate success
//             } else {
//                 setShowMessage({
//                     message: res?.message || 'Failed to save product consumption',
//                     messageType: 'error'
//                 });
//             }
//         } catch (error) {
//             console.error("Error saving product quantities:", error);
//             setShowMessage({
//                 message: error.message || 'Error saving product quantities',
//                 messageType: 'error'
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     if (!billId) return null;

//     return (
//         <Box sx={{ p: 2, width: '100%' }}>
//       {/* 🔹 Heading always left aligned */}
//       <Typography 
//         variant="h6" 
//         sx={{ fontWeight: 'bold', mb: 2, textAlign: 'left' }}
//       >
//         Add Product Consumption
//       </Typography>

//       {loading ? (
//         // 🔹 Loader perfectly centered wrt dialog width
//         <Box 
//           sx={{ 
//             display: 'flex', 
//             justifyContent: 'center', 
//             alignItems: 'center', 
//             minHeight: '250px', 
//             width: '100%' 
//           }}
//         >
//           <CircularProgress />
//         </Box>
//       ) : !hasMappedProducts ? (
//         <Box 
//           sx={{ 
//             display: 'flex', 
//             justifyContent: 'center', 
//             alignItems: 'center', 
//             minHeight: '200px' 
//           }}
//         >
//           <Typography variant="body1" color="textSecondary">
//             No mapped products found for this bill
//           </Typography>
//         </Box>
//       ) : (
//         <>
//           {/* 🔹 Bill Details Section aligned with table */}
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
//               Bill Date: {data?.dateOfBilling ? new Date(data.dateOfBilling).toLocaleDateString('en-GB') : ''}
//             </Typography>
//           </Box>

//           {/* 🔹 Consumption Table aligned with bill details */}
//           <Box sx={{ overflow: 'auto', maxHeight: '400px', mb: 2 }}>
//             <Table size="small" stickyHeader sx={{ minWidth: '100%' }}>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Service Name</TableCell>
//                   <TableCell>Product</TableCell>
//                   <TableCell>Quantity</TableCell>
//                   <TableCell>Unit</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {data?.services?.map((service, index) => {
//                   const hasProducts = service?.service?.mappedProducts?.length > 0;
//                   if (!hasProducts) return null;

//                   return (
//                     <TableRow key={index}>
//                       <TableCell>
//                         <Typography>{service.service.serviceName}</Typography>
//                       </TableCell>
//                       <TableCell>
//                         <FormControl fullWidth size="small">
//                           <Select
//                             value={selectedProducts[index] || ''}
//                             onChange={(e) => handleProductChange(index, e.target.value)}
//                             displayEmpty
//                           >
//                             <MenuItem value="">
//                               <em>Select Product</em>
//                             </MenuItem>
//                             {service.service.mappedProducts.map((product) => (
//                               <MenuItem
//                                 key={product._id}
//                                 value={product._id}
//                                 disabled={product.remainingProductVolume <= 0}
//                               >
//                                 {product.consumeableProductName} 
//                                 (Remaining: {product.remainingProductVolume} {product.remainingProductUnit})
//                               </MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </TableCell>
//                       <TableCell>
//                         <TextField
//                           type="number"
//                           size="small"
//                           value={quantities[index] || ''}
//                           onChange={(e) => handleQuantityChange(index, e.target.value)}
//                           fullWidth
//                           disabled={!selectedProducts[index]}
//                           placeholder={!selectedProducts[index] ? "Select product first" : ""}
//                           inputProps={{ min: 0 }}
//                         />
//                       </TableCell>
//                       <TableCell>
//                         <TextField
//                           value={units[index] || ''}
//                           fullWidth
//                           size="small"
//                           disabled
//                           sx={{
//                             '& .MuiInputBase-input': {
//                               textAlign: 'center'
//                             }
//                           }}
//                         />
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })}
//               </TableBody>
//             </Table>
//           </Box>

//           {/* 🔹 Action Buttons aligned right */}
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
//             <Button onClick={() => onClose(false)} variant="outlined" color="primary" disabled={loading}>
//               Cancel
//             </Button>
//             <Button onClick={handleSubmit} variant="contained" color="primary" disabled={loading}>
//               {loading ? <CircularProgress size={24} /> : 'Save Consumption'}
//             </Button>
//           </Box>
//         </>
//       )}
//     </Box>
//     );
// };

// export default AddProductConsume;

import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  MenuItem,
  Divider,
  Paper,
  Autocomplete
} from '@mui/material';
import { useMain } from 'src/views/hooks/useMain';

const AddProductConsume = ({ billId, onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [consumed, setConsumed] = useState({});
    const [mappedProductCount, setMappedProductCount] = useState(0);
  const { activeBranchId, setShowMessage, fetchServicesBillById, saveConsumedProducts } = useMain();

  useEffect(() => {
    if (activeBranchId && billId) getData();
  }, [activeBranchId, billId]);

  const getData = async () => {
    try {
      setLoading(true);
      const res = await fetchServicesBillById(billId, activeBranchId);
      if (res.statusCode === 200) {
        setData(res.data);
          let mappedProductCount = 0;
          res.data.services.forEach((service) => {
            mappedProductCount += service.service.mappedProducts.length;
          });
        setMappedProductCount(mappedProductCount);
        console.log(mappedProductCount, 'dfffffffff');
      } else {
        setShowMessage({
          message: res.message || 'Failed to fetch data',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: 'Error fetching bill data',
        messageType: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleQuantityChange = (serviceId, productId, value) => {
    setConsumed((prev) => ({
      ...prev,
      [serviceId]: {
        ...(prev[serviceId] || {}),
        [productId]: value,
      },
    }));
  };

  const handleSubmit = async () => {
    const consumedProducts = [];

    data?.services?.forEach((service) => {
      const mappedProducts = service?.service?.mappedProducts || [];
      const serviceId = service?.service?._id;
      const consumptionServiceProviderId = service?.serviceProvider || [];

      const productsForService = mappedProducts
        .filter((product) => {
          const quantity = consumed?.[serviceId]?.[product._id];
          return quantity && Number(quantity) > 0;
        })
        .map((product) => ({
          usedProductId: product._id,
          usedProductAmount: Number(consumed?.[serviceId]?.[product._id]),
          remainingProductUnit: product.remainingProductUnit || product.productUnit || 'ml',
        }));

      if (productsForService.length > 0) {
        consumedProducts.push({
          serviceId,
          consumptionServiceProviderId,
          usedProducts: productsForService,
        });
      }
    });

    if (consumedProducts.length === 0) {
      setShowMessage({
        message: 'Please select at least one product with valid quantity',
        messageType: 'error',
      });
      return;
    }

    const payload = {
      consumedProducts, // ✅ matches backend schema
      dateOfBilling: data?.dateOfBilling,
    };

    try {
      setLoading(true);
      const res = await saveConsumedProducts(billId, activeBranchId, payload);
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res?.message || 'Product consumption saved successfully',
          messageType: 'success',
        });
        onClose(true);
      } else {
        setShowMessage({
          message: res?.message || 'Failed to save product consumption',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Error saving consumption',
        messageType: 'error',
      });
    } finally {
      setLoading(false);
    }
  };


  if (!billId) return null;

  console.log(data, 'dataaaaaaattttttt')

  return (
    <Box sx={{ p: 1.5, width: '100%' }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        Add Product Consumption
      </Typography>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '220px' }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 1 }}>
            Bill Date:{' '}
            {data?.dateOfBilling ? new Date(data.dateOfBilling).toLocaleDateString('en-GB') : ''}
          </Typography>

          <Box sx={{ maxHeight: 420, overflowY: 'auto', pr: 1 }}>
            {data?.services?.map((service, sIndex) => {
              const mappedProducts = service?.service?.mappedProducts || [];

              return (
                <Paper
                  key={sIndex}
                  sx={{
                    mb: 2,
                    p: 1.5,
                    borderRadius: 1.5,
                    boxShadow: 1,
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                    {service?.service?.serviceName}
                  </Typography>

                  {mappedProducts.length > 0 ? (
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Product</TableCell>
                          <TableCell>Remaining Count</TableCell>
                          <TableCell>Remaining volume</TableCell>
                          <TableCell>Quantity</TableCell>
                          <TableCell>Unit</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {mappedProducts.map((product, pIndex) => (
                          <TableRow key={pIndex}>
                            <TableCell>{product.consumeableProductName}</TableCell>
                          
                              <TableCell style={{textAlign:'center'}}>
                                {product.consumeableProductCount} 
                              </TableCell>
                              <TableCell style={{textAlign:'center'}}>
                              {product.remainingProductVolume} 
                            </TableCell>
                            {/* <TableCell>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <TextField
                                  size="small"
                                  sx={{ width: 120 }}
                                  type="number"
                                  placeholder="Enter qty"
                                  inputProps={{ min: 0 }}
                                  value={consumed?.[service.service._id]?.[product._id] || ''}
                                  onChange={(e) =>
                                    handleQuantityChange(service.service._id, product._id, e.target.value)
                                  }
                                />
                                <TextField
                                  select
                                  size="small"
                                  sx={{ width: 80 }}
                                  value=""
                                  onChange={(e) =>
                                    handleQuantityChange(service.service._id, product._id, e.target.value)
                                  }
                                >
                                  {[5, 10, 15, 20, 25].map((val) => (
                                    <MenuItem key={val} value={val}>
                                      {val}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </Box>

                            </TableCell> */}
                            <TableCell>
                              <Autocomplete
                                freeSolo
                                disableClearable
                                options={[5, 10, 15, 20, 25].map(String)} // preset options
                                value={consumed?.[service.service._id]?.[product._id]?.toString() || ''}
                                onChange={(e, newValue) =>
                                  handleQuantityChange(service.service._id, product._id, newValue)
                                }
                                onInputChange={(e, newValue) =>
                                  handleQuantityChange(service.service._id, product._id, newValue)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    placeholder="Enter or select qty"
                                    sx={{
                                      width: 160,
                                      '& .MuiOutlinedInput-root': {
                                        padding: '3px 8px',
                                        fontSize: '14px',
                                      },
                                    }}
                                    inputProps={{
                                      ...params.inputProps,
                                      inputMode: 'numeric',
                                      pattern: '[0-9]*',
                                    }}
                                  />
                                )}
                                sx={{
                                  width: 160,
                                  '& .MuiAutocomplete-popupIndicator': { display: 'none' },
                                }}
                              />
                            </TableCell>

                            <TableCell>{product.productUnit}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  ) : (
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ textAlign: 'center', py: 1 }}
                    >
                      No product mapped for this service.
                    </Typography>
                  )}
                </Paper>
              );
            })}
          </Box>

          <Divider sx={{ my: 1.5 }} />

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5 }}>
            <Button onClick={() => onClose(false)} variant="outlined" color="primary" size="small">
              Cancel
            </Button>
              {mappedProductCount>0?(<Button
                onClick={handleSubmit}
                variant="contained"
                color="primary"
                size="small"
                disabled={loading}
              >
                {loading ? <CircularProgress size={20} /> : 'Save'}
              </Button>):""}
          </Box>
        </>
      )}
    </Box>
  );
};

export default AddProductConsume;



